









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({
  name: 'lb-flex-input',
})
export default class extends Vue {
  @Prop() private value!: string | number;
  @Prop() private placeholder!: string;

  private localValue = this.value;
  private inputHover = false;

  private handleSearch() {
    this.$emit('search', this.localValue);
  }

  private handleMouseEnter() {
    this.inputHover = true;
  }

  private handleMouseLeave() {
    if (!this.localValue) {
      this.inputHover = false;
    }
  }

  private handleClear() {
    this.$emit('clear');
  }

  @Watch('value')
  private onValueChange(val: string) {
    this.localValue = val;
  }

  @Watch('localValue')
  private onLocalValueChange(val: string) {
    this.$emit('input', val);
  }
}
